<template>


<div class="container">

  <div class="icon-left"><slot name="icon-left">
    <!-- default content of slot -->
    <ui-icon :icon="iconLeft" :backgroundColor="iconBg" color="707070"/>
  </slot></div>
  
  <div class="flex">
    <div v-if="title" class="title">{{title}}</div>
    <div class="descr">{{computeDescription}}</div>
  </div>
  <slot name="icon-right">
    <ui-icon v-if="iconRight" :icon="iconRight" backgroundColor="transparent" color="707070"/>
  </slot>
</div>


</template>

<script>
import UiIcon from '../UiIcon.vue';
import { helper } from '../../services/Helper.js';
export default {
  name: 'featured-button',
  props:{
    iconBg:{default:'#transparent'},
    iconLeft:{default:"dot-circle"},
    iconRight:{default:"angle-right"},
    title:{default:"not defined"},
    subtitle:{default:undefined}
  },
  data:function(){
    return {
    }
  },
  components:{
    UiIcon,
  },
  methods:{
  },
  computed:{
    computeDescription(){
        return helper.getExcerpt(this.subtitle);
    }
  },
  mounted:function(){
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.container{
  cursor:pointer;
  color:inherit;
  display:flex;
  
  align-items: center;
  padding: 25px 0;
  border-bottom: 1px solid #DDDDDD;
}

.container:first-child{
  border-top: 1px solid #DDDDDD;
  margin-top:15px;
}

.container:last-child{
  margin-bottom:15px;
}

.icon-left{
  margin-right:10px;
}
.flex{
    flex:1;
}
.title{
 word-break: break-all;
 font-weight:bold;
 margin-right:10px;
}
.descr{
 
  font-size: .8em;
  color: #646464;
 
}

</style>

